import { React } from 'react';
import { Box, Text, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon } from '@chakra-ui/react';

function StyledAccordionItem({ title, children }) {
  return (
    <AccordionItem
      bg='white'
      border='none'
      borderRadius='16px'
      boxShadow='0px 20px 20px -14px rgba(161, 161, 161, 0.160047)'
      mb='24px'>
      {({ isExpanded }) => (
        <>
          <AccordionButton _hover={{ borderRadius: '16px' }} py='18px' px='32px'>
            <Box flex='1' textAlign='left'>
              <Text
                fontSize='18px'
                fontWeight='500'
                color={isExpanded ? 'blue.600' : 'blue.500'}
                letterSpacing='-1px'
                fontFamily='K2D, sans-serif'>
                {title}
              </Text>
            </Box>
            <AccordionIcon boxSize={12} color={isExpanded ? 'blue.600' : 'blue.500'} />
          </AccordionButton>
          <AccordionPanel px='32px' pt='0px' pb='28px' mt='-4px'>
            {children}
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
}

export default StyledAccordionItem;
